<template>
  <section class="head-nav-bar-mini-container">
    <div class="cover" v-show="slideActive" @click="hideNav"></div>
    <div class="head-container">
      <img class="logo" src="../../assets/pc/xswap.png" @click="toHome">
      <div class="launch-app flex-center" @click="toUrl('open', homeLang.head[0].url)">{{ homeLang.launchApp }}</div>
      <img src="../../assets/mobile/header/slide.png"
           class="slide"
           :class="slideActive?'slide-active':'slide-normal'"
           @click.stop="setActive">
    </div>
    <div class="nav-list" v-if="slideActive">
      <ul class="outer-ul">
        <li v-for="(item, index) in homeLang.head">
          <div class="outer-container flex-center"
               :class="{ 'outer-container-bottom': !status[index]['active'] }"
               @click="setInnerActive(index, item.url)">
            <img class="mint" src="../../assets/pc/header/mint.gif" v-if="item.title === 'NFT'" />
            <span :class="{ 'text-active': status[index]['active'] }">{{ item.title }}</span>
            <img class="slide-icon" src="../../assets/mobile/header/down.png"
                 v-show="item.list&&!status[index]['active']">
            <img class="slide-icon" src="../../assets/mobile/header/up.png"
                 v-show="item.list&&status[index]['active']">
          </div>
          <ul class="inner-ul" v-show="item.list&&status[index]['active']">
            <li v-for="item1 in item.list">
              <a class="flex-center" :href="item1.url">
                <img v-if="item1.icon" :src="item1.icon">
                <span :class="{ 'no-icon': !item1.icon }">{{ item1.title }}</span>
                <div class="soon" v-if="item1.soon">{{ item1.soon }}</div>
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: "HeadNavBarMini",
  data() {
    return {
      slideActive: false,
      status: [{
        active: false,
      }, {
        active: false,
      }, {
        active: false,
      }, {
        active: false,
      }, {
        active: false,
      }, {
        active: false,
      }]
    }
  },
  props: {
    homeLang: {
      type: Object
    }
  },
  methods: {
    activeReset() {
      for(let item of this.status) {
        item.active = false
      }
    },
    hideNav() {
      this.slideActive = false
      this.activeReset()
    },
    setActive() {
      this.slideActive = !this.slideActive
      this.activeReset()
    },
    setInnerActive(index, url) {
      if (url) {
        location.href = url
        return false
      }
      const isActive = this.status[index]['active']
      this.activeReset()
      this.status[index]['active'] = !isActive
    },
    toHome() {
      this.$router.push('/'+this.lang+'/')
    }
  }
}
</script>

<style lang="less">
  .head-nav-bar-mini-container {
    .cover {
      height: 100vh;
      width: 100vw;
      position: fixed;
      opacity: 0.7;
      background: #000000;
      z-index: 9;
    }
    .head-container {
      height: 0.78rem;
      width: 100%;

      .logo {
        height: 0.44rem;
        margin-top: 0.3rem;
        margin-left: 0.2rem;
        display: block;
        float: left;
      }
      .launch-app {
        float: left;
        width: 1.68rem;
        height: 0.44rem;
        margin-left: 0.21rem;
        margin-top: 0.34rem;
        border: 0.5px solid #333333;
        border-radius: 0.22rem;
        font-size: 0.16rem;
        font-family: PingFangSC, PingFangSC-Medium;
        color: #333333;
      }
      .slide {
        float: right;
        margin-right: 0.48rem;
        margin-top: 0.4rem;
        width: 0.32rem;

        &.slide-active {
          transform: rotate(90deg);
          transition: transform 0.5s;
        }
        &.slide-normal {
          transition: transform 0.5s;
        }
      }
    }
    .nav-list {
      position: absolute;
      top: 0;
      width: 100%;
      background: white;
      z-index: 19;
      .outer-ul {
        >li {
          color: #333333;
          font-size: 13px;
          font-family: PingFangSC, PingFangSC-Regular;
          &:last-child {
            border-bottom: none;
          }
          .outer-container {
            margin: 0 16px;
            height: 59px;
            color: #333333;

            .mint {
              width: 15px;
            }
          }
          .outer-container-bottom {
            border-bottom: #eeeeee 0.5px solid;
          }
          .text-active {
            color: #2761E7;
          }
          .slide-icon {
            height: 4px;
            margin-left: 9px;
            transform: translateY(1px);
          }
          .inner-ul {
            background: #e8f1ff;
            >li {
              margin: 0 16px;
              height: 59px;
              border-bottom: #ffffff 0.5px solid;
              >a {
                width: 100%;
                height: 100%;
                position: relative;
                img {
                  height: 17px;
                }
                span {
                  margin-left: 9px;

                  &.no-icon {
                    margin-left: 0;
                  }
                }
                .soon {
                  position: absolute;
                  padding: 0 10px;
                  height: 25px;
                  line-height: 25px;
                  background-color: cornflowerblue;
                  color: white;
                  right: 10px;
                  top: 17px;
                  font-size: 12px;
                  border-radius: 13px;
                }
              }

            }
            &:last-child {
              border-bottom: none;
            }
          }
        }
      }
    }
  }
</style>
